import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '@/pages/Navbar/Navbar';
import Rodape from '@/pages/Rodape/Rodape';
import mulherAtendente from '@/assets/mulher-fone.jpg';
import axios from 'axios';

export default function Contatos() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    mensagem: '',
  });

const [enviando, setEnviando] = useState(false);
const [mostrarModal, setMostrarModal] = useState(false);


const handleTelefoneChange = (e) => {
  let valor = e.target.value.replace(/\D/g, '');

  if (valor.length > 11) valor = valor.slice(0, 11);

  if (valor.length <= 10) {
    valor = valor.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  } else {
    valor = valor.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
  }

  setFormData((prev) => ({ ...prev, telefone: valor }));
};

const [sugestoesEmail, setSugestoesEmail] = useState([]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleSubmit = async () => {
  if (!formData.email && !formData.telefone) {
    alert('Informe pelo menos um meio de contato: e-mail ou telefone.');
    return;
  }

  const isEmailValido = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  if (formData.email && !isEmailValido(formData.email)) {
    alert('O e-mail digitado é inválido.');
    return;
  }

  setEnviando(true);

  try {
    await axios.post('/api/public/api/contato', formData);
    setFormData({ nome: '', email: '', telefone: '', mensagem: '' });
    setEnviando(false);
    setMostrarModal(true);
  } catch (error) {
    setEnviando(false);
    console.error('Erro ao enviar:', error);
    alert('Erro ao enviar a mensagem. Tente novamente.');
  }
};


  return (
    <div className="bg-gradient-to-b from-gray-50 to-gray-100 text-gray-800 min-h-screen">
      <Navbar />

      <section className="max-w-6xl mx-auto px-4 py-16 grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Dados de contato */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="relative bg-white/80 backdrop-blur-md p-8 rounded-2xl shadow-xl border border-gray-200"
        >
<h2
  className="text-3xl md:text-4xl font-bold text-center mb-4"
  style={{
    fontFamily: "'Montserrat', sans-serif",
    color: '#C9AA7B',
  }}
>
  PRIME HIGIENIZAÇÕES
</h2>

          <p className="text-lg text-gray-600 mb-8 font-medium">
            Especializada em limpeza e higienização de estofados, cortinas e tapetes
          </p>

          <p className="font-semibold text-gray-800 mt-6 mb-2">WhatsApp:</p>
          <p className="text-gray-700 hover:text-[#C9AA7B] transition-colors duration-300">
            <a href="https://wa.me/(31) 99312-7020
" target="_blank" rel="noopener noreferrer">
              (31) 99312-7020
            </a>
          </p>

          <p className="font-semibold text-gray-800 mt-6 mb-2">E-mail:</p>
          <p className="text-gray-700 Hover:text-[#C9AA7B]transition-colors duration-300">
            <a href="mailto:higi.prime.vda@gmail.com">higi.prime.vda@gmail.com</a>
          </p>
        </motion.div>

        {/* Imagem da atendente */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="flex justify-center items-start"
        >
          <div className="relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              src={mulherAtendente}
              alt="Atendente"
              className="max-h-[400px] w-auto object-cover transform hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
          </div>
        </motion.div>
      </section>

      <div className="border-t border-gray-300 w-full max-w-6xl mx-auto my-8" />

      {/* Formulário */}
      <section className="max-w-6xl mx-auto px-4 pb-20">
<motion.h3
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  className="text-[22px] font-semibold text-center mb-6 uppercase"
  style={{
    fontFamily: "'Montserrat', sans-serif",
    color: '#C9AA7B',
  }}
>
  Entre em contato conosco
</motion.h3>


        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
  <motion.input
    type="text"
    name="nome"
    placeholder="Nome"
    value={formData.nome}
    onChange={handleInputChange}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: 0.1 }}
    className="w-full p-4 text-[16px] bg-white/80 backdrop-blur-md rounded-lg shadow-md border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#C9AA7B] transition-all duration-300"
  />

<div className="relative">
  <motion.input
    type="text"
    name="email"
    placeholder="E-mail"
    value={formData.email}
    onChange={(e) => {
      const { value } = e.target;
      setFormData((prev) => ({ ...prev, email: value }));

      if (value.includes('@') || value === '') {
        setSugestoesEmail([]);
      } else {
        const dominios = ['@gmail.com', '@hotmail.com', '@outlook.com'];
        const novasSugestoes = dominios.map((dom) => value + dom);
        setSugestoesEmail(novasSugestoes);
      }
    }}
    autoComplete="off"
    className="w-full p-4 text-[16px] bg-white/80 backdrop-blur-md rounded-lg shadow-md border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#C9AA7B] transition-all duration-300"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: 0.2 }}
  />

  {sugestoesEmail.length > 0 && (
    <ul className="absolute z-50 bg-white border border-gray-300 rounded-md shadow-md w-full mt-1">
      {sugestoesEmail.map((sugestao, index) => (
        <li
          key={index}
          className="px-4 py-2 hover:bg-[#f9f3ee] cursor-pointer text-sm"
          onClick={() => {
            setFormData((prev) => ({ ...prev, email: sugestao }));
            setSugestoesEmail([]);
          }}
        >
          {sugestao}
        </li>
      ))}
    </ul>
  )}
</div>

<motion.input
  type="tel"
  name="telefone"
  placeholder="Telefone"
  value={formData.telefone}
  onChange={handleTelefoneChange}
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6, delay: 0.3 }}
  className="w-full p-4 text-[16px] bg-white/80 backdrop-blur-md rounded-lg shadow-md border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#C9AA7B] transition-all duration-300"
/>



  <motion.textarea
    name="mensagem"
    placeholder="Mensagem"
    value={formData.mensagem}
    onChange={handleInputChange}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: 0.4 }}
    className="w-full col-span-1 md:col-span-3 p-4 text-[16px] h-48 resize-none bg-white/80 backdrop-blur-md rounded-lg shadow-md border border-gray-300 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#C9AA7B] transition-all duration-300"
  />

  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: 0.5 }}
    className="col-span-1 md:col-span-3 flex justify-start"
  >

<button
  onClick={handleSubmit}
  disabled={enviando}
  className="bg-[#C9AA7B] hover:bg-[#b8936a] text-white font-semibold py-3 px-8 rounded-full shadow-lg transform hover:scale-105 transition-all duration-300 disabled:opacity-60"
  style={{ fontFamily: "'Montserrat', sans-serif" }}
>
  {enviando ? 'Enviando...' : 'Enviar Mensagem'}
</button>

          </motion.div>
        </div>
      </section>
<AnimatePresence>
  {mostrarModal && (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/70 flex justify-center items-center z-[9999]"
    >
      <motion.div
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.8 }}
        className="bg-white rounded-2xl p-8 shadow-2xl max-w-md text-center space-y-4"
      >
        <h2 className="text-2xl font-bold text-[#C9AA7B]">Agradecemos o contato!</h2>
        <p className="text-gray-700 text-lg">
          Em breve retornaremos. Esperamos que esteja gostando do nosso ambiente,<br />
          feito com todo carinho para você, cliente 💛
        </p>
        <button
          onClick={() => setMostrarModal(false)}
          className="mt-4 px-6 py-2 bg-[#C9AA7B] hover:bg-[#b8936a] text-white rounded-full shadow"
        >
          Fechar
        </button>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

      <Rodape />
    </div>
  );
}